<template>
  <footer id="contato">
    <div class="container">
      <div class="logo-footer">
        <img alt="Portal Ulbrex" src="~@/assets/logo.svg" />
      </div>

      <div class="content-footer">
        <div class="box-footer box-phone">
          <h3>Links</h3>
          <router-link :to="{ name: 'Home' }" exact>
            Início
          </router-link>
          <router-link :to="{ name: 'TermsOfUse' }" exact>
            Termos e privacidade
          </router-link>
        </div>

        <div class="box-footer box-social">
          <h3>Siga-nos</h3>
          <div class="icons">
            <a
              v-for="(social_link, index) in social_links"
              :key="index"
              :href="social_link.link"
              target="_blank"
            >
              <img :src="social_link.icon" :alt="social_link.name" width="30" />
            </a>
          </div>
        </div>

        <div class="box-footer box-contact">
          <a href="http://www.anbima.com.br/pt_br/index.htm" target="_blank">
            <img src="@/assets/icons/selo-autorregulacao.jpeg" />
            <img src="@/assets/icons/selo-gestao.jpeg" />
          </a>
        </div>
      </div>
    </div>

    <div class="all-rights">
      © Ulbrex 2021. Todos os direitos reservados.
      <router-link :to="{ name: 'TermsOfUse' }" exact>
        Termos e privacidade
      </router-link>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",

  data() {
    return {
      social_links: [
        {
          name: "Instagram",
          link: "https://www.instagram.com/deznoventa",
          icon: require("@/assets/icons/instagram.svg")
        },
        {
          name: "Facebook",
          link: "https://www.facebook.com/mudejadeznoventa",
          icon: require("@/assets/icons/facebook.svg")
        },
        {
          name: "Youtube",
          link: "https://www.youtube.com/channel/UC47-W7PM-F7cr9YRfAxPf3Q",
          icon: require("@/assets/icons/youtube.svg")
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
footer {
  margin: 0 auto;
  height: 400px;

  .container {
    padding: 80px 0 80px 0;
    display: flex;
    justify-content: space-between;
    max-width: 930px;
  }

  .logo-footer {
    img {
      display: block;
      width: 180px;
      height: auto;
    }
  }

  .content-footer {
    display: flex;
    align-items: center;

    .box-footer {
      width: 180px;
      height: 100%;
      margin: 0 0 0 36px;

      .icons {
        display: flex;

        a {
          padding-right: 8px;
        }
      }
    }

    .box-contact {
      width: 280px;
      margin: 0;

      img {
        padding: 2px;
        max-width: 140px;

        @media (max-width: 768px) {
          max-width: 95px;
        }
      }
    }

    h3 {
      color: var(--blue-custom);
      font-weight: 700;
      font-family: var(--font-primary);
      font-size: var(--size-regular);
      line-height: 29px;
      margin-bottom: 25px;
    }

    a {
      display: block;
      text-decoration: none;
      font-size: var(--size-large);
      line-height: 29px;
      font-weight: 400;
      padding-bottom: 6px;
      color: var(--atomic);
      transition: color 0.2s ease-in-out;

      &:hover,
      &:active,
      &:focus {
        transition: color 0.2s ease-in-out;
        color: var(--light-blue);
      }
    }
  }

  .all-rights {
    width: 100%;
    min-height: 72px;
    padding: 21px 180px;
    background-color: var(--grey);
    font-size: 16px;
    font-weight: 400;

    a {
      color: var(--atomic);
      transition: color 0.2s ease-in-out;

      &:hover,
      &:active,
      &:focus {
        transition: color 0.2s ease-in-out;
        color: var(--light-blue);
      }
    }
  }

  @media (max-width: 768px) {
    padding: 32px 0;

    .container {
      margin: 0 32px;
      flex-direction: column;
    }

    .logo-footer {
      margin-bottom: 12px;
      img {
        width: 180px;
        padding-bottom: 50px;
      }
    }

    .content-footer {
      flex-direction: column;
      align-items: flex-start;

      .box-footer {
        width: 80%;
        margin: 0 0 12px;
      }
    }

    .all-rights {
      padding: 20px 20px;
    }
  }
}
</style>
